import makeStyles from '@material-ui/core/styles/makeStyles';
import { ICheckoutTheme } from '../../../../../common/theme/ICheckoutTheme';

export type TermsAndConditionModalClasses =
  | 'dialog'
  | 'dialogPaper'
  | 'dialogTitle'
  | 'dialogContent'
  | 'dialogActions'
  | 'disclaimerText'
  | 'dialogTitleContent'
  | 'iconButton'
  | 'acceptButton';

const termsAndConditionModalStyles = makeStyles<ICheckoutTheme, TermsAndConditionModalClasses>(
  ({ palette }) => ({
    dialog: {},
    dialogPaper: {
      borderRadius: 0,
    },
    dialogTitle: {
      padding: '10px 24px 10px 24px',
    },
    dialogTitleContent: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      color: palette.primary.main,
    },
    dialogContent: {},
    dialogActions: {
      padding: '10px 20px 10px 20px',
    },
    disclaimerText: {
      marginBottom: 20,
    },
    iconButton: {
      width: 26,
      height: 26,
      padding: 0,
      color: palette.common.white,
      backgroundColor: palette.primary.main,
      '&:hover': {
        color: palette.common.white,
        backgroundColor: palette.primary.main,
      },
    },
    acceptButton: {
      margin: '0 auto',
      borderRadius: 0,
      width: '100%',
      color: palette.common.white,
      maxWidth: 'unset',
      '&:hover': {
        backgroundColor: palette.primary.main,
      },
    },
  }),
  { name: 'Checkout4_TermsAndConditionModal' },
);

export default termsAndConditionModalStyles;
